import React from 'react';
import ArrayInput from './ArrayInput';

const InterviewProcessSection = ({
  jobData,
  newInterviewStep,
  setNewInterviewStep,
  handleInterviewStepAdd,
  handleInterviewStepRemove
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Interview Process</h3>
      
      <ArrayInput
        label="Interview Steps"
        arrayName="interview_process"
        items={jobData.interview_process}
        newValue={newInterviewStep}
        onValueChange={setNewInterviewStep}
        onAdd={handleInterviewStepAdd}
        onRemove={handleInterviewStepRemove}
        placeholder="Add an interview step..."
      />
    </div>
  );
};

export default InterviewProcessSection;